import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';

const GrupoReglaCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="show">
      <TextInput source="descripcion" validate={[required()]} />
    </SimpleForm>
  </Create>
);

export default GrupoReglaCreate;
